import script from "./caseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./caseDetails.vue?vue&type=script&setup=true&lang=js"

import "./caseDetails.vue?vue&type=style&index=0&id=67194ff0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\liuqi\\Desktop\\R\\website-vue3-antd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67194ff0"]])

export default __exports__